import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from '@/common/i18n/locales/en.json';
import fr from '@/common/i18n/locales/fr.json';
import it from '@/common/i18n/locales/it.json';
import Config from '@/services/config.service'
const config = new Config();
Vue.use(VueI18n);

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }
  },
  fr: {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }
  },
  it: {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }
  }
};

const numberFormats = {
  fr: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  it: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  }
};

const i18n = new VueI18n({
  locale: config.i18n.defaultLocale || 'fr',
  fallbackLocale: config.i18n.fallbackLocale || 'fr',
  messages: { en, fr, it },
  dateTimeFormats,
  numberFormats
});

export default i18n;
